<template>
    <div class="main-content pt-5 m-h-100">
        <div class="result mt-3 mb-3">
            {{ data?.length }} Result(s)
        </div>

        <div class="desktopview">
            <div class="wrapper">
                <div class="my-row d-flex justify-content-between align-items-center" v-for="(i, index) in data"
                :key="index">
                <div>{{ i.id }}</div>
                <div>{{ i.flat_no }}</div>
                <div>{{ i.block }}</div>
                <div>{{ i.beds }} Bedroom Apartment</div>
                <!-- <div>{{ i.sq_feet }}ft</div> -->
                <div class="d-flex align-items-center">
                    <span class="color-box " :class="i.status"></span>
                    <span class="status" >{{ (i.status) == 'available' ?  i.status : i.show_status }}</span>
                </div>
                <div>
                    <!-- <button class="btn view-btn" data-bs-toggle="modal" type="button" data-bs-target="#exampleModal">View</button> -->
                    <button class="btn view-btn" @click="ShowEditModal(i)"   v-if="fromcms == true">Edit</button>
                    <button class="btn view-btn" @click="i.open = true" v-if="fromcms != true">View</button>
                </div>
            </div>
            </div>
        </div>

        <div class="mobileview">
            <div class="mobile-row d-flex justify-content-between align-items-center" v-for="(i, index) in data"
                :key="index">
                <div>{{ i.id }}</div>
                <div>{{ i.flat_no }}</div>
                <div>{{ i.block }}</div>
                <div>{{ i.beds }} Bedroom Apartment</div>
                <!-- <div> {{ i.sq_feet }}ft </div> -->
                <div class="d-flex align-items-center">
                    <span class="color-box text-capitalize" :class="i.status"></span>
                    <span class="text-capitalize" >{{ (i.status) == 'available' ? i.status : i.status }}</span>
                </div>
                <div>
                    <!-- <button class="btn view-btn" data-bs-toggle="modal" type="button" data-bs-target="#exampleModal">View</button> -->
                    <button class="btn view-btn" @click="ShowEditModal(i)" v-if="fromcms == true">Edit</button>
                    <button class="btn view-btn" @click="i.open = true; OpenIndex = index" v-if="fromcms != true">View</button>
                </div>
            </div>
        </div>

        <div class="modal fade" id="show-modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Edit {{ EditModalData.flat_no }}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="fitler-one">
                        <p>Status</p>
                        <div class="d-flex justify-content-between">
                            <label class="chk-radio">
                                <input type="radio" name="radio" value="reserved" :checked="EditModalData.status === 'reserved'" @change="UpdateValue($event)">
                                <span class="checkmark"></span>
                                Reserved
                            </label>

                            <label class="chk-radio">
                                <input type="radio" name="radio" value="sold" :checked="EditModalData.status === 'sold'" @change="UpdateValue($event)">
                                <span class="checkmark"></span>
                                Sold
                            </label>

                            <label class="chk-radio">
                                <input type="radio" name="radio" value="available" :checked="EditModalData.status === 'available'" @change="UpdateValue($event)">
                                <span class="checkmark"></span>
                                Available
                            </label>

                            <label class="chk-radio">
                                <input type="radio" name="radio" value="not-released" :checked="EditModalData.status === 'not-released'" @change="UpdateValue($event)">
                                <span class="checkmark"></span>
                                Unreleased
                            </label>
                        </div>
                    </div>

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    <button type="button" class="btn btn-primary theme-bg-color" @click="SaveValue(EditModalData.id)">Update</button>
                </div>
                </div>
            </div>
        </div>

        <VueFinalModal v-for="(i, index) in data" v-model="i.open" :key="index" :drag="true" :esc-to-close="true"
            :hide-overlay="true" :prevent-click="true" :fit-parent="false" :click-to-close="false" :lock-scroll="false"
            :style="{ 'top': '5%', 'width': '50%', 'left': '22%',  'zIndex': '3' }" :content-style="{ 'width': '100%' }" :z-index-auto="true"
            :z-index="true" :z-index-base="1000000" @click="BringFront(index)" :id="index" :class="i.open ? 'opened' : ''">
            <div style="width: 100%" v-if="i.open" >
                <FloorDetails :viewtype="'plot_number'" :id="i.id" @CloseInnerModal="i.open = false" :fromfavourites="false"/>
            </div>
        </VueFinalModal>
    </div>
</template>

<script>


import { $vfm, VueFinalModal, ModalsContainer } from 'vue-final-modal'
import FloorDetails from '@/components/FloorDetails/FloorDetails.vue';
import { Modal } from 'bootstrap'



export default {
    name: "SearchFilterList",
    components: {
        VueFinalModal,
        FloorDetails,
    },
    props: {
        fromcms: Boolean,
        data: []
    },
    methods: {
        ShowEditModal(i){
            this.EditModalData = i;
            this.FormValue = this.EditModalData.status;
           

            this.myModal = new Modal(document.getElementById('show-modal'));
            this.myModal.show();
        },
        UpdateValue(event){
            this.FormValue = event.target.value;
        },

        UpdatePrice(event){
            this.PriceValue = event.target.value;
        },

        SaveValue(i){
            fetch(this.base_url+'UpdateFloorStatus&id='+i+'&status='+this.FormValue+'&session_id='+sessionStorage.getItem('session_id'))
            .then(response => response.json())
            .then(res => {
                //console.log(res)
                //this.apartments = res.data.apartments
            });

            this.data.forEach( (e)=> {
                console.log(e)
                if(e.id == i){
                    e.status = this.FormValue;
                    e.show_status = this.FormValue.replace('-',' ');
                }
            })
            this.myModal.hide();
        },
        NumFilter(e) {
            //console.log(e)
        },
        BringFront(index){
            
          let list = [];
          list = document.getElementsByClassName('opened');
          for (let item of list) {
              if(item.classList.contains('opened')){
                  if(item.id == index.toString()){
                    
                      item.style.zIndex = 4;
                  }else{
                      item.style.zIndex = 3;
                  }
              }
          }            
        },
        formatPrice(value) {
            let val = (value/1)
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        }
    },
    data() {
        return {
            FormValue: null,
            PriceValue: null,
            showModal: false,
            myModal: null ,
            EditModalData: {},
            route: "",
            OpenIndex: null,
            top: "10%",
        };
    },

    
    
}

</script>

<style lang="scss" scoped>
* {
    font-family: "rustica-regular" !important;
}


.btn {
    text-transform:uppercase;
    border-radius:0;
}

.available {
    //background:#E0E0D4;
    background:#00ca00
}

.not-released {
    background:#E0E0D4;
}

.wrapper{    
    width: 100%;
    height: calc(100vh - 240px);
    overflow: hidden;
    overflow-y: hidden;
    display: block;
    overflow-y: scroll;
    // scrollbar-width: none;
    // &::-webkit-scrollbar {
    //     display: none; /* Chrome, Safari, Opera */
    // }
}

.sold {
    background: red;
}

.reserved {
    background: orange;
}

.fitler-one{
    color: #355063;
}

.chk-radio {
    display: block;
    position: relative;
    padding-left: 35px;
    margin-bottom: 12px;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

/* Hide the browser's default radio button */
.chk-radio input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
}

/* Create a custom radio button */
.checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 25px;
    width: 25px;
    border-radius: 50%;
    border: 1px solid #355063;
}

.chk-radio:hover input~.checkmark {
    background-color: #ccc;
}

/* When the radio button is checked, add a blue background */
.chk-radio input:checked~.checkmark {
    background-color: #cad636;
}

.theme-bg-color{
    background-color: #cad636;
    border-color:#cad636;
}

.theme-bg-color:hover{
    background-color: #381b31;
    border-color:#381b31;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
    content: "";
    position: absolute;
    display: none;
}

/* Show the indicator (dot/circle) when checked */
.chk-radio input:checked~.checkmark:after {
    display: block;
}

/* Style the indicator (dot/circle) */
.chk-radio .checkmark:after {
    left: 8px;
    top: 5px;
    width: 6px;
    height: 12px;
    border: solid white;
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
}



.main-content {
    
    padding-bottom: 75px;
    min-height:100%;
    .result {
        color: #fff;
        margin: 0 70px ;
        text-transform: uppercase;
    }

    .my-row {
        background: #fff;
        height: 50px;
        margin: 0px 0 0 70px;
        padding: 0 10px;
        color: #000;
        box-shadow: 0px 5px 10px -4px #888888;
        border:1px solid #888888; 
        text-transform:uppercase;
        letter-spacing:2.5px;
        div {
            width: calc(100%/6);
            text-align: center;
            font-family: "rustica-light" !important;
            span{
                font-family: "rustica-light" !important;
            }
            .color-box {
                width: 10px;
                height: 10px;
                margin-right: 10px;
                border-radius:15px
            }

            .available {
                //background:#E0E0D4;
                    background:#00ca00
            }

            .not-released {
                background:#E0E0D4;
            }

            .sold {
                background: red;
            }

            .reserved {
                background: orange;
            }

            .view-btn {
                background: #cad636;
                color: #fff;
                width: auto;
                text-align: center;
                //font-family: "aeonik-bold" !important;
            }

        }

        :nth-child(1) {
            width: 5%;
            //font-family: "aeonik-bold" !important;
        }

        :nth-child(2) {
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
        }

        :nth-child(4) {
            width: 35%;
            //font-family: "aeonik-bold" !important;
        }

    }

    .mobileview {
        display: none;
        padding-bottom: 70px;
    }

    .mobile-row {
        background: #fff;
        margin: 10px 10px;
        padding: 10px 15px;
        color: #355063;
        flex-wrap: wrap;
        box-shadow: 0px 0px 10px 0px #888888;

        div {
            text-align: center;

            .color-box {
                width: 15px;
                height: 15px;
                margin-right: 10px;
            }

            .view-btn {
                background: #cad636;
                color: #fff;
                width: auto;
                text-align: center;
                letter-spacing: 2.5px;
                //font-family: "aeonik-bold" !important;
            }
        }

        div:nth-child(1) {
            width: 8%;
            text-align: left;
        }

        div:nth-child(2) {
            width: 30%;
        }

        div:nth-child(3) {
            width: 62%;
        }

        div:nth-child(4) {
            width: 70%;
            justify-content: right;
            
        }

        div:nth-child(5) {
            width: 30%;
            text-align: right;
        }

        div:nth-child(6) {
            width: 100%;
            text-align: right;
            margin-top:10px

        }
    }

    @media screen and (max-width: 1100px) {
        .status {
            display: none !important;
        }

        .mobile-row div:nth-child(2) {
            width: 25%;
            text-align: center;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
        }

        .my-row div:nth-child(2) {
            text-align: center;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
        }

        .my-row div:nth-child(5) {
            width:auto !important
        }
    }

    @media screen and (max-width: 1366px) {
   .vfm--fixed {
        width: 60% !important;
        left:30% !important
    }
}


    @media screen and (max-width: 810px) {


        .vfm--fixed {
            width: 60% !important;
            left:20% !important
        }

         .mobile-row div:nth-child(2) {
            text-align: center;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
        }

    }

    @media screen and (max-width: 809px) {
        .result{
            margin-left:10px
        }

        .desktopview {
            display: none !important;
        }

        .mobileview {
            display: block;
        }

    }

    @media screen and (max-width: 767px) {
    
    .vfm--fixed {
        width: 100% !important;
        left: 0 !important;
        top: 70px !important;
        z-index: 2014 !important;
    }
}
}
</style>